import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationRunsController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationRunsController.php
* @route '/api/batch-operations/runs'
*/
const GetBatchOperationRunsController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetBatchOperationRunsController.url(options),
    method: 'get',
})

GetBatchOperationRunsController.definition = {
    methods: ["get","head"],
    url: '/api/batch-operations/runs',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationRunsController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationRunsController.php
* @route '/api/batch-operations/runs'
*/
GetBatchOperationRunsController.url = (options?: RouteQueryOptions) => {
    return GetBatchOperationRunsController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationRunsController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationRunsController.php
* @route '/api/batch-operations/runs'
*/
GetBatchOperationRunsController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetBatchOperationRunsController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\BatchOperation\GetBatchOperationRunsController::__invoke
* @see app/Http/Controllers/BatchOperation/GetBatchOperationRunsController.php
* @route '/api/batch-operations/runs'
*/
GetBatchOperationRunsController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetBatchOperationRunsController.url(options),
    method: 'head',
})

export default GetBatchOperationRunsController